module.exports = __webpack_public_path__ + "static/media/pdx-all floors.74ad2b3a.pxm";